module.exports = __webpack_public_path__ + "static/scale-model-of-uss-cod-submarine-memorial-in-cleveland-ohio-c714d3e22f2f6e3b1c1efd637798bc3e.png";